module.exports = __webpack_public_path__ + "static/media/java.869711c1.svg";